import types from './mutation-types';
import ItemService from '@/services/item-service';

const actions = {
	getBid({ commit }, { itemId, bidId }) {

		commit(types.FETCH_BID_START);

		return ItemService.getBid(itemId, bidId)
			.then(bid => commit(types.FETCH_BID_SUCCESS, bid))
			.catch(error => commit(types.FETCH_BID_ERROR, error.response.data));

	},
	updateBid({ commit }, { itemId, bidId, bid }) {

		commit(types.UPDATE_BID_START);

		return ItemService.updateBid(itemId, bidId, bid)
			.then(bid => commit(types.UPDATE_BID_SUCCESS, bid))
			.catch(error => commit(types.UPDATE_BID_ERROR, error.response.data));

	},
	deleteBid({ commit }, { itemId, bidId }) {

		commit(types.DELETE_BID_START);

		return ItemService.deleteBid(itemId, bidId)
			.then(response => commit(types.DELETE_BID_SUCCESS))
			.catch(error => commit(types.DELETE_BID_ERROR, error.response.data));

	},
	resetAll({ commit }) {
		commit(types.RESET_ALL);
	}
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/bid-form/actions.js